import axios from 'axios'
import store from '@/store';
import router from '@/router';
const instance = axios.create({
    // baseURL: 'http://api.novigodemo.com/',
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
    }
})


instance.interceptors.request.use(
    (config) => {
        // console.log("store", store.state.selectedFacility.id)
        let token = store.state.oidcStore.access_token;

        if (store.state.selectedFacility) {
            let facilityId = store.state.selectedFacility.id
            config.headers['FacilityID'] = facilityId;
        }
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;

        }
        config.baseURL = store.state.settings.apiFileUrl;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(null, error => {
    let path = '/dashboard';
    if (store.state.oidcStore.user.role !='SuperAdmin' && store.state.oidcStore.user.role !='Vendor'  ) {
        path = '/profile'
    }
    else if(store.state.oidcStore.user.role =='Vendor'){
        path='/vendor-trip-sheet'
    }
    else {
        path = '/dashboard';
    }
    if (error.response.status == 401) {
        router.push(path);
        return Promise.reject(error);
    }
    return Promise.reject(error);

});

export default instance;